enum DeviceFamilies {
  Android = "Android",
  iOS = "iOS",
  Oculus = "Oculus",
  OpenVR = "OpenVR",
  Pico = "Pico",
  Unknown = "Unknown",
  None = "None",
  Web = "Web",
  Windows = "Windows",
  OSX = "OSX",
  Linux = "Linux",
};

export default DeviceFamilies;